
<template class="body"  style="'background-color':#000 ">
  <template v-if="setup === false">
    <setupgame @setupcontent="setup" />
  </template>

  <template v-if="setup === true">
    <leaderBoard />
  </template>
</template>


<script>
import leaderBoard from "./components/leaderBoard.vue";
import setupgame from "./components/setup.vue";

export default {
  name: "App",
  components: {
    leaderBoard,
    setupgame,
  },
  data() {
    return {
      info: "",
      name: "",
      startsound: false,
      count: 1,
      license: "",
      boxid: "",
      setup: false,
      encryptionEnd: "",
      startMessages: "",
      gameData: "",
    };
  },
  async mounted() {
    // window.setInterval( async() => {
    //     if (localStorage.getItem("leaderBoardLicense") === null ) {
    //        this.setup = false
    //     } else {
    //      this.setup = true
    //      this.license = localStorage.getItem('leaderBoardLicense');
    //  }
    // }, 1000)
  },
  methods: {
    setupcontent() {
      console.log("throw");
      this.setup = true;
    },
  },
};
</script>

<style>
@import "./assets//styles.css";
</style>



